// extracted by mini-css-extract-plugin
export default {"table":"RelatedItems_table__-n+Xh","tableContent":"RelatedItems_tableContent__VJxQ4"};